// extracted by mini-css-extract-plugin
export default {"root":"GFGHLvV7kKcOU43L7zvD","messageText":"cYoADRCT1G3zCu3fbDbD","critical":"npTeIo1v6l_nllYzfpYw","placeHolderShimmer":"A9MixzsHhFG_RSJCgERw"};